// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./files/RobotoCondensed-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./files/RobotoCondensed-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./files/RobotoCondensed-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./files/RobotoCondensed-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./files/RobotoCondensed-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./files/RobotoCondensed-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./files/RobotoCondensed-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./files/RobotoCondensed-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./files/RobotoCondensed-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Roboto Condensed';
    font-style: normal;
    font-display: swap;
    font-weight: 100;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
    font-family: 'Roboto Condensed';
    font-style: normal;
    font-display: swap;
    font-weight: 200;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
    font-family: 'Roboto Condensed';
    font-style: normal;
    font-display: swap;
    font-weight: 300;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
    font-family: 'Roboto Condensed';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

@font-face {
    font-family: 'Roboto Condensed';
    font-style: normal;
    font-display: swap;
    font-weight: 500;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}

@font-face {
    font-family: 'Roboto Condensed';
    font-style: normal;
    font-display: swap;
    font-weight: 600;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}

@font-face {
    font-family: 'Roboto Condensed';
    font-style: normal;
    font-display: swap;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}

@font-face {
    font-family: 'Roboto Condensed';
    font-style: normal;
    font-display: swap;
    font-weight: 800;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
}

@font-face {
    font-family: 'Roboto Condensed';
    font-style: normal;
    font-display: swap;
    font-weight: 900;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/robotoCondensed/index.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAuH;AAC3H;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAmI;AACvI;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAyH;AAC7H;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAA6H;AACjI;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAA2H;AAC/H;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAA+H;AACnI;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAuH;AAC3H;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAiI;AACrI;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAyH;AAC7H","sourcesContent":["@font-face {\n    font-family: 'Roboto Condensed';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 100;\n    src: url(./files/RobotoCondensed-Thin.ttf) format('truetype'), url(./files/RobotoCondensed-Thin.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Roboto Condensed';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 200;\n    src: url(./files/RobotoCondensed-ExtraLight.ttf) format('truetype'), url(./files/RobotoCondensed-ExtraLight.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Roboto Condensed';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 300;\n    src: url(./files/RobotoCondensed-Light.ttf) format('truetype'), url(./files/RobotoCondensed-Light.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Roboto Condensed';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 400;\n    src: url(./files/RobotoCondensed-Regular.ttf) format('truetype'), url(./files/RobotoCondensed-Regular.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Roboto Condensed';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 500;\n    src: url(./files/RobotoCondensed-Medium.ttf) format('truetype'), url(./files/RobotoCondensed-Medium.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Roboto Condensed';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 600;\n    src: url(./files/RobotoCondensed-SemiBold.ttf) format('truetype'), url(./files/RobotoCondensed-SemiBold.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Roboto Condensed';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 700;\n    src: url(./files/RobotoCondensed-Bold.ttf) format('truetype'), url(./files/RobotoCondensed-Bold.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Roboto Condensed';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 800;\n    src: url(./files/RobotoCondensed-ExtraBold.ttf) format('truetype'), url(./files/RobotoCondensed-ExtraBold.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Roboto Condensed';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 900;\n    src: url(./files/RobotoCondensed-Black.ttf) format('truetype'), url(./files/RobotoCondensed-Black.ttf) format('truetype');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
